module.exports = __webpack_public_path__ + "img/new_chat_main_icon.f58eebd.png";